/**
 * Learn guides live under /blog. One learn slug collides with a blog post
 * slug, so it gets a distinct /blog slug; every other guide keeps its slug.
 */
const BLOG_SLUG_OVERRIDES: Record<string, string> = {
  "leadership-skills-for-kids": "leadership-skills-for-kids-guide",
};
export function learnBlogSlug(learnSlug: string): string {
  return BLOG_SLUG_OVERRIDES[learnSlug] ?? learnSlug;
}

/** Merged duplicate blog posts: source slug -> surviving guide slug (301). */
export const BLOG_MERGED_REDIRECTS: Record<string, string> = {
  "how-to-build-confidence-in-children": "how-to-build-confidence-in-child",
  "leadership-skills-for-kids-8-14": "leadership-skills-for-kids-guide",
};
